(() => {
  if (window.__elxWaterPurifierCatalogV3Loaded) return;
  window.__elxWaterPurifierCatalogV3Loaded = true;

  let pendingScrollY = null;
  let drawerObserver;

  const rootsIn = (scope) => {
    if (!scope?.querySelectorAll) return [];
    const roots = [...scope.querySelectorAll('[data-elx-wp-catalog]')];
    if (scope.matches?.('[data-elx-wp-catalog]')) roots.unshift(scope);
    return roots;
  };

  const waitForCartActions = async () => {
    if (window.ElxCartActions?.addItemsToCart) return window.ElxCartActions;
    await new Promise((resolve) => {
      const startedAt = Date.now();
      const check = () => {
        if (window.ElxCartActions?.addItemsToCart || Date.now() - startedAt >= 2400) resolve();
        else window.setTimeout(check, 80);
      };
      check();
    });
    return window.ElxCartActions;
  };

  const restorePageScroll = () => {
    if (pendingScrollY === null) return;
    const targetY = pendingScrollY;
    [0, 40, 140, 320].forEach((delay) => {
      window.setTimeout(() => {
        const dialog = document.querySelector('cart-drawer-component [data-testid="cart-drawer-dialog"]');
        if (!dialog?.hasAttribute('open')) window.scrollTo({ top: targetY, left: 0, behavior: 'auto' });
      }, delay);
    });
    window.setTimeout(() => { pendingScrollY = null; }, 700);
  };

  const observeDrawer = () => {
    const dialog = document.querySelector('cart-drawer-component [data-testid="cart-drawer-dialog"]');
    if (!dialog || dialog === drawerObserver?.dialog) return;
    drawerObserver?.observer.disconnect();
    let wasOpen = dialog.hasAttribute('open');
    const onClose = () => restorePageScroll();
    const observer = new MutationObserver(() => {
      const isOpen = dialog.hasAttribute('open');
      if (wasOpen && !isOpen) onClose();
      wasOpen = isOpen;
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.addEventListener('close', onClose);
    drawerObserver = { dialog, observer };
  };

  const announce = (form, message, isError = false) => {
    if (!isError) return;
    const status = form.closest('.elx-wp-catalog__card')?.querySelector('[data-elx-wp-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-error', true);
  };

  const init = (scope = document) => {
    observeDrawer();
    rootsIn(scope).forEach((root) => {
      if (root.dataset.elxWpCatalogV3Ready === 'true') return;
      root.dataset.elxWpCatalogV3Ready = 'true';
      root.querySelectorAll('[data-elx-wp-add-form]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('[data-elx-wp-add-button]');
          const variantId = Number(new FormData(form).get('id'));
          if (!button || !variantId || button.disabled) return;

          pendingScrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');

          try {
            const actions = await waitForCartActions();
            if (!actions?.addItemsToCart) throw new Error('Cart is not ready. Please try again.');
            await actions.addItemsToCart({
              items: [{ id: variantId, quantity: 1 }],
              sourceId: root.id || 'elx-water-purifier-catalog',
              source: 'water-purifier-collection-catalog',
            });
          } catch (error) {
            announce(form, error?.message || 'Unable to add to cart.', true);
          } finally {
            button.removeAttribute('aria-busy');
            window.setTimeout(() => { button.disabled = false; }, 1200);
          }
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
